<template>
	<ul class="checkbox-group">
		<li v-for="(item,index) in permission">

			<div class="checkbox checkbox-primary">
				<input :id="'checkbox'+index" class="styled" type="checkbox" :checked="item.checked" v-bind:value="item.id" name="checkGroup"  @change="eleChange">
				<label :for="'checkbox'+index">
		       	{{item.permissionname}}
		    </label>
			</div>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'checkbox',
		data() {
			return {
			}
		},
		props: ['permission'],
		components: {},
		created: function() {},
		mounted: function() {},
		computed: {},
		methods: {
			eleChange: function($event) {
				let arr = []
				$(".checkbox-group>li").each(function(e){
					if($(this).find("input[type=checkbox]:checked").val()){
						arr.push($(this).find("input[type=checkbox]:checked").val())
					}
				})
				arr = arr.join("&&")
				this.$emit('theChange', arr)
			},
			changeState: function(el) {
				if(el.readOnly) el.checked = el.readOnly = false;
				else if(!el.checked) el.readOnly = el.indeterminate = true;
			}
		}

	}
</script>

<style scoped="">
	@import url("../../static/css/build.css");
	.checkbox label {
		display: inline-block;
		vertical-align: middle;
		position: relative;
		padding-right: 30px;
		line-height: 36px;
	}
	
	.checkbox label::before {
		left: auto!important;
		right: 0px!important;
		top: 11px!important;
		margin-left: -20px;
		border: 1px solid #cccccc;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.checkbox label::after {
		right: 0;
		left: auto!important;
		top: 0;
		margin-left: -20px;
		padding-left: 3px;
		padding-top: 1px;
		font-size: 11px;
		color: #555555;
	}
	
	.checkbox-primary input[type="checkbox"]:checked+label::before,
	.checkbox-primary input[type="radio"]:checked+label::before {
		background-color: #4068EE;
		border-color: #4068EE;
	}
	
	.checkbox-primary input[type="checkbox"]:checked+label::after,
	.checkbox-primary input[type="radio"]:checked+label::after {
		color: #fff;
	}
	
	.checkbox {
		height: 36px;
		border: 1px solid #D0D2D9;
		border-radius: 2px;
		padding-right: 12px;
		display: inline-block;
	}
	
	input[type="checkbox"] {
		margin-right: 12px;
		top: 9px;
		right: 2px!important;
	}
	
	.checkbox {
		margin-top: 0px!important;
		margin-bottom: 0px!important;
	}
	.checkbox-group>li {
		float: left;
		margin-right: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/checkBox.vue